// @ts-nocheck
import React, { Fragment } from 'react';
// material
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
// containers
import DatePicker from 'commons/components/DatePicker';
// icons
import AddIcon from '@material-ui/icons/Add';

function FormInputs(props) {
  const { t } = useTranslation();

  return (
    <>
      <Grid item sm={6} xs={12}>
        <DatePicker
          inputId="date"
          label={t('Date')}
          fullWidth
          value={props.controls.date}
          onChange={props.changeControls}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          value={props.controls.description}
          onChange={props.changeControls}
          fullWidth
          id="description"
          label={t('Reason')}
          error={props.invalidControls.description}
          helperText={props.invalidControls.description && t('Enter a reason')}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <TextField
          type="number"
          value={props.controls.dispatchNumber}
          onChange={props.changeControls}
          fullWidth
          id="dispatchNumber"
          label={t('Dispatch number')}
          error={props.invalidControls.dispatchNumber}
          helperText={props.invalidControls.dispatchNumber && t('Enter a dispatch number')}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Button
          fullWidth
          size="small"
          startIcon={<AddIcon />}
          onClick={props.setDispatchLots}
          variant="contained"
          className={props.classes.filterButton}
          color="primary">
          {t('Search')}
        </Button>
      </Grid>
    </>
  );
}

export default FormInputs;
